export const AI_AGENT_CONFIG_TABS = {
	QUICK_LAUNCH: "QUICK_LAUNCH",
	CONFIGURATION: "CONFIGURATION",
	HISTORY: "HISTORY",
};
